import React from "react";
import styled from "styled-components";
import { ICAMNavroute } from '../../../utils/ICAMnavroute.js';
import IUMRSNavBar from "./IUMRSNavbar.jsx";
import IUMRSFooter from "./IUMRSFooter";
import { commitee } from "../../../utils/IUMRScommitee.js";
import NotificationDropdown from "../../../hooks/notificationsDropdown.jsx";


const Internationalcommitee = () => {

    const advisory = [
        {
            id: 1,
            name: 'PROF. RODRIGO MARTINS',
            affiliation: 'Portugal',
        },
        {
            id: 2,
            name: 'PROF. W. A. ASOMANING',
            affiliation: 'Ghana',
        },
        {
            id: 3,
            name: 'PROF. WOHN SOO LEE',
            affiliation: 'South Korea',
        },
        {
            id: 4,
            name: 'PROF. WOLE SOBOYEJO',
            affiliation: 'USA',
        },
        {
            id: 5,
            name: 'PROF. YAA NTIAMOAH BAIDU',
            affiliation: 'Ghana',
        },
        {
            id: 6,
            name: 'PROF. B.V.R. CHOWDARI',
            affiliation: 'IOC Chairman, Singapore',
        }
    ]

    const IOC = [
        {
            id: 1,
            name: 'PROF. ANIL KUMAR',
            affiliation: 'IUMRS President',
        },
        {
            id: 2,
            name: 'PROF. LIANG LU',
            affiliation: 'China',
        },
        {
            id: 3,
            name: 'PROF. CLARA SANTATO ',
            affiliation: 'Canada',
        },
        {
            id: 4,
            name: 'PROF. OSVALDO NOVAIS DE OLIVEIRA JUNIOR',
            affiliation: 'IUMRS Brazil',
        },
        {
            id: 5,
            name: 'LESLEY CORNISH',
            affiliation: 'South Africa',
        },
        {
            id: 6,
            name: 'PROF. HAREE RAMASAWMY',
            affiliation: 'Mauritius'
        },
        {
            id: 5,
            name: 'PROF. MANYALA NCHOLU',
            affiliation: 'South Africa',
        },
        {
            id: 6,
            name: 'PROF. CHIHARU TOKORO',
            affiliation: 'Japan'
        },
        {
            id: 7,
            name: 'PROF. KAZUKI NAGASHIMA',
            affiliation: 'Japan'
        },
        {
            id: 8,
            name: 'PROF. PETRA RUDOLF',
            affiliation: 'Netherlands'
        },
        {
            id: 9,
            name: 'PROF. ANGE NZIHOU',
            affiliation: 'France',
        }
    ]
    return (
    <Wrapper>
        <IUMRSNavBar  navroute={ICAMNavroute}/>
        <NotificationDropdown />
        <Header>
            <div className="header">
                <h2>INTERNATIONAL COMMITTEE</h2>
            </div> 
        </Header>

        <LocalOrganizers>
            <HeaderContainer>
                <HeaderDivider>
                    <div className="line"></div>
                        <div className="diamond">
                        <Title>Advisory Board</Title>
                        </div>
                    <div className="line"></div>
                </HeaderDivider>
            </HeaderContainer>
            <CommitteeGrid>
                {advisory.slice(0, 6).map((advisory) => (
                <MemberCard key={commitee.advisory}>
                    <div className="name">{advisory.name}</div>
                    <div className="affiliation">{advisory.affiliation}</div>
                </MemberCard>
                ))}
            </CommitteeGrid>
        </LocalOrganizers>
        <LocalOrganizers>
        <HeaderContainer>
                <HeaderDivider>
                    <div className="line"></div>
                        <div className="diamond">
                        <Title>International Organzing Committee</Title>
                        </div>
                    <div className="line"></div>
                </HeaderDivider>
            </HeaderContainer>
            <CommitteeGrid>
                {IOC.slice(0, 21).map((IOC) => (
                <MemberCard key={IOC.id}>
                    <div className="name">{IOC.name}</div>
                    <div className="affiliation">{IOC.affiliation}</div>
                </MemberCard>
                ))}
            </CommitteeGrid>
        </LocalOrganizers>
        <IUMRSFooter />
    </Wrapper>
    )
}

const Wrapper = styled.div`
  background-color: white;
`

const LocalOrganizers = styled.div`
  padding: 4rem 5%;
  max-width: 1400px;
  margin: 3rem auto;
`
const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const HeaderDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  .line {
    height: 2px;
    background-color: #d1d5db;
    width: 7rem;
  }

  .diamond {
    margin: 0 1rem;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #1f2937;
`;

const Header = styled.div`
  .header {
    width: 100%;
    height: 10rem;
    background-color: #082D4A;
    margin: 0;
    text-align: center;
    
    h2 {
      margin: 0;
      color: white;
      font-family: "PT Serif", serif;
      font-style: normal;
      font-weight: 600;
      letter-spacing: .005em;
      font-size: 1.5rem;
      line-height: 10rem;
    }
  }

   @media only screen and (min-width: 800px) {
        .header{
            h2{font-size: 2rem;}
        }
    }

`

const CommitteeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const MemberCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-left: 5px solid #082D4A;
  min-height: 7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  }

  .name {
    font-weight: 700;
    font-size: 1.1rem;
    margin-bottom: 1rem;
    color:  #CA9D3B;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .affiliation {
    font-size: 1rem;
    color: #666;
    text-align: center;
  }
`;

export default Internationalcommitee;